import { render, staticRenderFns } from "./createMenu.vue?vue&type=template&id=647fb2bb&"
import script from "./createMenu.vue?vue&type=script&lang=js&"
export * from "./createMenu.vue?vue&type=script&lang=js&"
import style0 from "./createMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports